import { useState } from 'react';
import { Button, Modal, Table, Tooltip } from 'antd';
import { camelToPara } from '../../../helpers/caseConverters';

export function ExtraInfoComponent({ data }) {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const tableData = Object.entries(data?.info).map(([key, value], index) => ({
    key: index,
    property: key,
    value: value.toString(),
  }));

  const columns = [
    {
      dataIndex: 'property',
      key: 'property',
      render: (text) => <span>{camelToPara(text)}</span>,
    },
    {
      dataIndex: 'value',
      key: 'value',
      render: (text) => <span>{camelToPara(text)}</span>,
    },
  ];

  return (
    <Tooltip title="More">
      <Button
        type="primary"
        onClick={showModal}
        className="ant-btn btn orange-btn-text"
      >
        Extra Info
      </Button>
      <Modal
        title="More Details"
        open={isModalVisible}
        onCancel={handleCancel}
        footer={[
          <Button key="close" onClick={handleCancel}>
            Close
          </Button>,
        ]}
      >
        <Table
          columns={columns}
          dataSource={tableData}
          pagination={false}
          showHeader={false}
          bordered
        />
      </Modal>
    </Tooltip>
  );
}
